<template>
  <Prodnav> </Prodnav>
  <!-- navbar start from here -->
  <!-- sticky navbar -->
  <nav
    class="nav navbar-expand-lg navbar-light fixed w-full nav_marg top-0 left-0"
    style="background-color: #0c152f"
  >
    <a class="navbar-brand ml-5" href="/" style="color: white">
      <div class="" id="loading" style="visibility: hidden">
        <img
          :src="'/imgs/ic_fav_3.png'"
          class="img-fluid img_size"
          alt=""
          loading="lazy"
        />
      </div>
    </a>
    <button
      class="navbar-toggle"
      type="button"
      data-toggle="collapse"
      data-target="#navbarSupportedContent2"
      aria-controls="navbarSupportedContent2"
      aria-expanded="false"
      aria-label="Toggle navigation"
    >
      <span class="navbar-toggler-icon"></span>
    </button>

    <div
      class="collapse navbar-collapse mr-5 my-2"
      id="navbarSupportedContent2"
    >
      <ul class="navbar-nav navs ml-auto">
        <li class="nav-item">
          <!--<a v-bind:href =" url('/') " class="nav-link home-nav-link  ">Home</a> -->
          <a href="#Features" class="act nav-link home-nav-link">Features</a>
        </li>
        <li class="nav-item">
          <a class="nav-link 1" href="#Advantages">Advantages</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" href="#Benefits">Benefits</a>
        </li>
        <li class="nav-item">
          <a href="#Pricing" class="nav-link">Pricing</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" href="#Stories">Case Studies</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" href="#Faq">Faq's</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" href="#Testimonial">Testimonial</a>
        </li>
      </ul>
    </div>
  </nav>
  <!-- navbar end -->

  <div class="slider py-4">
    <div class="container">
      <div class="grid md:grid-cols-2 grid-cols-1 gap-2">
        <div class="pt-5 pr-5">
          <h2 class="text-white">Your Gateway Into Product</h2>
          <p class="text-white py-3">
            CityScapes is a fully responsive and customizable landing page
            template. All images can easily be replaced from the html side,
            without having to dig through the
          </p>
          <button
            class="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
          >
            Get Started
          </button>
        </div>
        <div>
          <img :src="'/imgs/intro.png'" loading="lazy" alt="" class="py-1" />
          <!-- <h3>Aruvaa's Product page</h3> -->
        </div>
      </div>
    </div>
  </div>
  <!--    Putting in the click dots   -->

  <!-- Features start -->

  <div id="Features"></div>

  <section class="service-section py-5">
    <div class="container">
      <div class="row justify-content-center py-3">
        <div class="col-md-8 col-12 text-center">
          <p class="service-main-heading">Features</p>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6 col-lg-6 col-12">
          <div class="icon-box">
            <i class="fa fa-briefcase service-icon"></i>
            <p class="service-title"><a href="#">Lorem Ipsum</a></p>
            <p class="service-para">
              Voluptatum deleniti atque corrupti quos dolores et quas molestias
              excepturi sint occaecati cupiditate non provident
            </p>
          </div>
        </div>
        <div class="col-md-6 col-lg-6 col-12 mt-4 mt-md-0">
          <div class="icon-box">
            <i class="fa fa-clipboard service-icon"></i>
            <p class="service-title"><a href="#">Dolor Sitema</a></p>
            <p class="service-para">
              Minim veniam, quis nostrud exercitation ullamco laboris nisi ut
              aliquip ex ea commodo consequat tarad limino ata
            </p>
          </div>
        </div>
        <div class="col-md-6 col-lg-6 col-12 mt-4 mt-md-0">
          <div class="icon-box">
            <i class="fa fa-chart-bar service-icon"></i>
            <p class="service-title"><a href="#">Sed ut perspiciatis</a></p>
            <p class="service-para">
              Duis aute irure dolor in reprehenderit in voluptate velit esse
              cillum dolore eu fugiat nulla pariatur
            </p>
          </div>
        </div>
        <div class="col-md-6 col-lg-6 col-12 mt-4 mt-md-0">
          <div class="icon-box">
            <i class="fa fa-binoculars service-icon"></i>
            <p class="service-title"><a href="#">Nemo Enim</a></p>
            <p class="service-para">
              Excepteur sint occaecat cupidatat non proident, sunt in culpa qui
              officia deserunt mollit anim id est laborum
            </p>
          </div>
        </div>
        <div class="col-md-6 col-lg-6 col-12 mt-4 mt-md-0">
          <div class="icon-box">
            <i class="fa fa-cog service-icon"></i>
            <p class="service-title"><a href="#">Magni Dolore</a></p>
            <p class="service-para">
              At vero eos et accusamus et iusto odio dignissimos ducimus qui
              blanditiis praesentium voluptatum deleniti atque
            </p>
          </div>
        </div>
        <div class="col-md-6 col-lg-6 col-12 mt-4 mt-md-0">
          <div class="icon-box">
            <i class="fa fa-calendar-alt service-icon"></i>
            <p class="service-title"><a href="#">Eiusmod Tempor</a></p>
            <p class="service-para">
              Et harum quidem rerum facilis est et expedita distinctio. Nam
              libero tempore, cum soluta nobis est eligendi
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- features end -->

  <!-- Advantages start -->
  <div id="Advantages"></div>
  <section class="amazing_feature">
    <div class="container">
      <div class="col-md-12 text-center heading-main">
        <p class="advantages same">Advantages</p>
      </div>
      <div class="grid xl:grid-cols-3 md:grid-cols-2 sm:grid-cols-1 gap-4">
        <div class="single_feature">
          <div class="feature_icon"><i class="far fa-heart"></i></div>
          <h3>Made with Love</h3>
          <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit Cras.</p>
        </div>

        <!-- ... -->
        <div class="single_feature">
          <div class="feature_icon"><i class="fa fa-magic"></i></div>
          <h3>Powerful</h3>
          <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit Cras.</p>
        </div>

        <!-- ... -->
        <div class="single_feature">
          <div class="feature_icon"><i class="fas fa-location-arrow"></i></div>
          <h3>Send Messages</h3>
          <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit Cras.</p>
        </div>

        <!-- ... -->
        <div class="single_feature">
          <div class="feature_icon"><i class="far fa-money-bill-alt"></i></div>
          <h3>Save Money</h3>
          <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit Cras.</p>
        </div>

        <!-- ... -->
        <div class="single_feature">
          <div class="feature_icon"><i class="fa fa-cog"></i></div>
          <h3>Customizable</h3>
          <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit Cras.</p>
        </div>

        <!-- ... -->
        <div class="single_feature">
          <div class="feature_icon"><i class="fa fa-database"></i></div>
          <h3>Data Report</h3>
          <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit Cras.</p>
        </div>
      </div>
    </div>
    <!--- END CONTAINER -->
  </section>
  <!-- Advantages end here -->

  <!-- benefits start -->
  <div id="Benefits"></div>
  <br />
  <section class="py-5 benefit">
    <div class="container">
      <div class="text-center">
        <p class="benefits">Benefits of borrowing from products</p>
      </div>

      <div
        class="grid xl:grid-cols-2 md:grid-cols-2 sm:grid-cols-1 justify-between gap-4"
      >
        <div>
          <div class="unIndentedList">
            <h5 class="text-gray-400">We provide you real what matter's</h5>
            <ul class="list mt-4">
              <li class="font-bold">
                <span class="d-flex">
                  <img :src="'/imgs/benefiticon.png'" loading="lazy" alt="" />
                  Flexible and multiple staffing</span
                >
              </li>
              <p class="text-sm ml-4">
                Lorem ipsum dolor sit amet consectetur adipisicing elit. Earum
                esse fugiat provident natus sint, voluptates totam error minus
                perferendis atque eius ad .
              </p>
              <li class="font-bold">
                <span class="d-flex">
                  <img :src="'/imgs/benefiticon.png'" loading="lazy" alt="" />
                  Customised service
                </span>
              </li>
              <p class="text-sm ml-4">
                Lorem ipsum dolor sit amet consectetur adipisicing elit. Earum
                esse fugiat provident natus sint, voluptates totam error minus
                perferendis atque eius ad .
              </p>
              <li class="font-bold">
                <span class="d-flex">
                  <img :src="'/imgs/benefiticon.png'" alt="" />
                  Top Quality
                </span>
              </li>
              <p class="text-sm ml-4">
                Lorem ipsum dolor sit amet consectetur adipisicing elit. Earum
                esse fugiat provident natus sint, voluptates totam error minus
                perferendis atque eius ad .
              </p>
            </ul>
          </div>
        </div>
        <!-- ... -->
        <div>
          <img :src="'/imgs/Productbenefit.png'" loading="lazy" alt="" />
        </div>
      </div>
    </div>
  </section>
  <!-- benefits end -->

  <!-- Pricing Plans start from here -->
  <div id="Pricing"></div>
  <br />
  <div class="container mb-5 mt-5">
    <div class="text-center">
      <p class="pricings">Pricing Plans</p>
    </div>

    <!-- Tab Section With ID attribute Start -->
    <div class="container">
      <ul class="prodNav">
        <li @click="onChangePlan('monthly')" class="ptItem active">Monthly</li>
        <li @click="onChangePlan('quarterly')" class="ptItem">Quaterly</li>
        <li @click="onChangePlan('yearly')" class="ptItem">Yearly</li>
      </ul>
      <!-- Tab Section With ID attribute End -->

      <div
        class="xl:grid-cols-4 lg:grid-cols-2 md:grid-cols-2 sm:grid-cols-1 flex justify-center gap-4"
      >
        <div
          class="card card-pricing popular text-center px-1 mb-4"
          v-for="(data, key) in plansDataSorted"
          style="box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px"
        >
          <span
            class="h6 w-52 mx-auto px-4 py-1 rounded-bottom bg-primary text-white shadow-sm"
            >{{ data.display_name }}</span
          >
          <div class="bg-transparent card-header pt-4 border-0">
            <h1
              class="h1 font-weight-normal text-primary text-center mb-0"
              data-pricing-value="15"
            >
              ₹<span class="price">{{
                data.rlt_cnslproduct_cnslsubscriptionprice[0]
                  .rlt_cnslsubscriptionprice_cnslsubscriptionpriceslab[0].price
              }}</span>
            </h1>
          </div>

          <div class="card-body pt-0">
            <ul class="list-unstyled mb-4">
              <li>Up to 5 users</li>
              <li>Basic support on Github</li>
              <li>Monthly updates</li>
              <li>Free cancelation</li>
            </ul>
            <jet-button
              v-if="!needAuthentication"
              @click="
                moveToNextPage(
                  data.id,
                  data.rlt_cnslproduct_cnslsubscriptionprice[0].id
                )
              "
              class="w-full"
            >
              <button type="button" class="w-full p-2 bg-blue-500 text-white">
                Try for free
              </button></jet-button
            >

            <!-- ye uncomment kr dena hai testing k  bd -->

            <!-- <a :href="route('login')"   v-if="needAuthentication" class="w-full">
              <button type="button" class="w-full p-2 bg-blue-500 text-white">
                Try for free
              </button></a> -->

            <a
              v-if="needAuthentication"
              @click="
                saveCookies(
                  data.id,
                  data.rlt_cnslproduct_cnslsubscriptionprice[0].id
                )
              "
              class="w-full"
            >
              <button type="button" class="w-full p-2 bg-blue-500 text-white">
                Try for free
              </button></a
            >
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- pricing end here -->

  <!-- case study start from here -->
  <div id="Stories"></div>
  <br />
  <section class="pb-5 pt-5 case" id="services">
    <div class="container">
      <div class="row">
        <div class="col-lg-12">
          <div class="text-center">
            <p class="story">Customer Success Stories</p>
          </div>
        </div>
        <div class="offset-lg-3 col-lg-6">
          <div class="center-text">
            <p>
              We work together with our customers to create positive,longlasting
              value.
            </p>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-lg-3 col-sm-6">
          <a href="#" class="services-small-item">
            <div class="icon">
              <i class="far fa-check-square"></i>
            </div>
            <h5 class="services-title">Lorem Ipsum</h5>
            <p>
              Lorem Ipsum is simply dummy text of the printing and typesetting
              industry.
            </p>
            <div class="button">
              <i class="fa fa-chevron-right"></i>
            </div>
          </a>
          <div class="item-bg"></div>
        </div>
        <div class="col-lg-3 col-sm-6">
          <a href="#" class="services-small-item">
            <div class="icon">
              <i class="fa fa-bed"></i>
            </div>
            <h5 class="services-title">Lorem Ipsum</h5>
            <p>
              Lorem Ipsum is simply dummy text of the printing and typesetting
              industry.
            </p>
            <div class="button">
              <i class="fa fa-chevron-right"></i>
            </div>
          </a>
          <div class="item-bg"></div>
        </div>
        <div class="col-lg-3 col-sm-6">
          <a href="#" class="services-small-item">
            <div class="icon">
              <i class="fas fa-chart-bar"></i>
            </div>
            <h5 class="services-title">Lorem Ipsum</h5>
            <p>
              Lorem Ipsum is simply dummy text of the printing and typesetting
              industry.
            </p>
            <div class="button">
              <i class="fa fa-chevron-right"></i>
            </div>
          </a>
          <div class="item-bg"></div>
        </div>
        <div class="col-lg-3 col-sm-6">
          <a href="#" class="services-small-item">
            <div class="icon">
              <i class="fa fa-shopping-cart"></i>
            </div>
            <h5 class="services-title">Lorem Ipsum</h5>
            <p>
              Lorem Ipsum is simply dummy text of the printing and typesetting
              industry.
            </p>
            <div class="button">
              <i class="fa fa-chevron-right"></i>
            </div>
          </a>
          <div class="item-bg"></div>
        </div>
      </div>
      <a href="#" target="_blank" class="btn primary mb-3"> All Stories</a>
    </div>
  </section>
  <!-- Case study end here -->

  <!-- faq's start from here -->
  <div id="Faq"></div>
  <br />
  <section class="mt-4 p-4">
    <div class="container">
      <div class="text-center">
        <p class="faq">Frequently Asked Questions</p>
      </div>
      <!-- faq content -->
      <div class="cont" v-for="(data, key) in faq">
        <div class="question">{{ data.name }}</div>
        <div class="answercont">
          <div class="answer">
            {{ data.answer }}
            <br /><br />
          </div>
        </div>
      </div>

      <a href="#" target="_blank" class="grey mb-3"> View All &rarr;</a>
      <!-- <a href="#" title="Catchy Title" role="button" class="button text-right">View All &rarr;</a>  -->
    </div>
  </section>
  <!-- faq's end here -->

  <!-- testimonial start from here -->
  <div id="Testimonial"></div>
  <br />
  <section class="testimonial text-center">
    <div class="container">
      <div
        class="top_border border-y-2 border-black"
        style="background-color: white"
      >
        <!-- <div class="heading white-heading">
                Testimonial
            </div> -->
        <h1 class="mb-10 pt-8 text-gray-600 font-bold">What Say Our Client</h1>

        <div
          id="testimonial4"
          class="carousel slide testimonial4_indicators testimonial4_control_button thumb_scroll_x swipe_x"
          data-ride="carousel"
          data-pause="hover"
          data-interval="5000"
          data-duration="2000"
        >
          <div class="carousel-inner" role="listbox">
            <div>
              <div
                v-for="(value, key) in successStory"
                :class="key == 0 ? 'carousel-item active' : 'carousel-item '"
              >
                <div
                  class="grid grid-cols-4 gap-0 testimonial4_slider justify-center"
                >
                  <div
                    class="slider_img border-2"
                    style="box-shadow: rgba(0, 0, 0, 0.16) 0px 1px 4px"
                  >
                    <img
                      src="https://i.ibb.co/8x9xK4H/team.jpg"
                      class="img-responsive"
                      loading="lazy"
                    />
                    <h5 class="text-left">{{ value.name }}</h5>
                  </div>
                  <div class="col-span-3">
                    <img
                      :src="'/imgs/quotes.png'"
                      class=""
                      loading="lazy"
                      alt=""
                      style="
                        position: relative;
                        left: 0%;
                        font-size: 50px;
                        color: white;
                        margin-top: 0px;
                      "
                    />
                    <!-- <i class="fa fa-quote-right testimonial-quote-icon " ></i> -->
                    <div
                      class="border-2 mt-1 px-2 py-3"
                      style="box-shadow: rgba(0, 0, 0, 0.16) 0px 1px 4px"
                    >
                      <span
                        class="grid grid-cols-3 gap-4 border-b-2 border-gray-300"
                      >
                        <div class="">
                          <h5>{{ value.company_name }}</h5>
                          <p class="text-xs">{{ value.designation }}</p>
                        </div>
                        <div class=""></div>
                        <div class="...">
                          &#11088; &#11088; &#11088; &#11088; &#11088;
                        </div>
                      </span>
                      <p class="pt-1">{{ value.story }}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <a
            class="carousel-control-prev"
            href="#testimonial4"
            data-slide="prev"
          >
            <span class="carousel-control-prev-icon"></span>
          </a>
          <a
            class="carousel-control-next"
            href="#testimonial4"
            data-slide="next"
          >
            <span class="carousel-control-next-icon"></span>
          </a>
        </div>
      </div>
    </div>
  </section>
  <!-- testinomial end here -->

  <!-- footer start from here -->
  <Footer> </Footer>
  <!-- footer end -->
</template>

<script>
import Prodnav from "@/Layouts/ProdNav.vue";
import Footer from "@/Layouts/Footer.vue";
import AppLayout from "@/Layouts/AppLayout.vue";
import JetNavLink from "@/Jetstream/NavLink.vue";

export default {
  props: {
    canLogin: Boolean,
    canRegister: Boolean,
    needAuthentication: Boolean,
    subscriptionProductId: String,
    plansData: String,
    faq: {
      type: Array,
      default: [],
    },
    successStory: {
      type: Array,
      default: [],
    }
  },
  components: {
    AppLayout,
    Prodnav,
    JetNavLink,
    Footer,
  },

  data() {
    return {
      monthValue: 30,
      quaterValue: 60,
      yearlyValue: 90,
      Testimonials: [
        { name: "neha" },
        { name: "surbhi" },
        { name: "tarun" },
        { name: "saurabh" },
      ],
    };
  },
  methods: {
    carausel(val) {
      console.log(val);
    },
  },
  mounted() {
    // faq section

    let question = document.querySelectorAll(".question");
    this.getMonthlyPrice();
    console.log("Success Story", this.successStory);
    console.log("needAuthentication Value", this.needAuthentication);
    question.forEach((question) => {
      question.addEventListener("click", (event) => {
        const active = document.querySelector(".question.active");
        if (active && active !== question) {
          active.classList.toggle("active");
          active.nextElementSibling.style.maxHeight = 0;
        }
        question.classList.toggle("active");
        const answer = question.nextElementSibling;
        if (question.classList.contains("active")) {
          answer.style.maxHeight = answer.scrollHeight + "px";
        } else {
          answer.style.maxHeight = 0;
        }
      });
    });

    $(document).ready(function () {
      var pTabItem = $(".prodNav .ptItem");
      $(pTabItem).click(function () {
        // Tab nav active functionality
        $(pTabItem).removeClass("active");
        $(this).addClass("active");

        // Tab container active functionality
        var tabid = $(this).attr("id");
        $(".prodMain").removeClass("active");
        $("#" + tabid + "C").addClass("active");

        return false;
      });
      // nav js start
      $(".nav-link").on("click", function () {
        $(this).parent().parent().find("a").removeClass("act");
        $(this).addClass("act");
      });
    });
    $(window).scroll(function () {
      if ($(this).scrollTop() > 100) {
        // if ($(this).scrollTop() > 1429.5999755859375) {
        //    $('.Advantages').addClass('act');
        // }
        $(".nav").addClass("sticky");
        $("#loading").css("visibility", "visible");
      } else {
        $(".nav").removeClass("sticky");
        $("#loading").css("visibility", "hidden");
      }
    });
    // nav ends

    if (document.cookie.indexOf("aruvaaProductPage=") >= 0) {
      var cookieValue = document.cookie
        .split("; ")
        .find((row) => row.startsWith("aruvaaProductPage="))
        .split("=")[1];

      console.log("COOKIES VALUE", cookieValue);
    }
  },
  methods: {
    onChangePlan(value) {
      if (value == "quarterly") {
        this.monthValue = 300;
      } else if (value == "yearly") {
        this.monthValue = 3000;
      } else {
        this.monthValue = 30;
      }

      if (value == "quarterly") {
        this.quaterValue = 600;
      } else if (value == "yearly") {
        this.quaterValue = 6000;
      } else {
        this.quaterValue = 60;
      }

      if (value == "quarterly") {
        this.yearlyValue = 900;
      } else if (value == "yearly") {
        this.yearlyValue = 9000;
      } else {
        this.yearlyValue = 90;
      }
    },
    moveToNextPage(subplanid, subscriptionPriceId) {
      //var option = $(elements).children("option:selected").val();

      //console.log(subid);
      //make an array of all the selected options

      console.log("marketplaces ROUTE", route("marketplaces.organisations"));

      if (this.needAuthentication == false) {
        var data = {
          subscriptionProductId: this.subscriptionProductId,
          subscriptionPlanId: subplanid,
          subscriptionPriceId: subscriptionPriceId,
        };
        this.$inertia.post(route("marketplaces.organisations"), data);
      }

      //this.$inertia.post(route("marketplaces.accounts"), data);
    },

    getMonthlyPrice() {
      console.log(
        "PRICE DATA",
        this.plansData[0].rlt_subscriptionprice_morphtomany
      );
    },
    saveCookies(subplanid, subscriptionPriceId) {
      console.log("PRODUCT PAGE saved cookies", this.subscriptionProductId);
      let obj = {
        subscriptionPlanId: subplanid,
        subscriptionPriceId: subscriptionPriceId,
        subscriptionProductId: this.subscriptionProductId,
      };

      console.log("marketplaces ROUTE", route("marketplaces.organisations"));

      axios.post('/marketplaces/store-selected-plan', { obj })
        .then(response => {
        console.log("store-selected-plan"+response);
            window.location.href = '/login';
        });

     // var jsonString = JSON.stringify(obj);
      // Set the cookie with the user's name and email
      // document.cookie =
      //   "aruvaaProductPage=" + jsonString + ";domain=.aruvaa.net.in;path=/";

      // document.cookie = jsonString;
    },
  },

  computed: {
    plansDataSorted() {
      // console.log("PLAN_DATA_SORTED",_.orderBy(this.plansData, 'sort_position'));
      //sort the plansData by sort_postion
      return _.orderBy(this.plansData, "sort_position");
    },
  },
};
</script>

<style>
html {
  scroll-behavior: smooth;
}
@media screen and (prefers-reduced-motion: no-preference) {
  html {
    scroll-behavior: smooth;
  }
}

* {
  box-sizing: border-box;
}
.nav_marg {
  margin-top: 2.25rem;
}
.slider {
  background-color: #0c152f;
  width: 100%;
  background-size: cover;
  background-repeat: no-repeat;
  margin-top: 6.4rem;
}
/* features card css */
.service-section {
  background-color: #f3f3f3;
}
.service-section .icon-box {
  margin-bottom: 20px;
  padding: 30px;
  border-radius: 6px;
  background-color: #f8f9fa;
}
.service-section .icon-box:hover .service-title a {
  color: #41a1fd;
}
.service-section .icon-box .service-icon {
  float: left;
  color: #41a1fd;
  font-size: 40px;
}
.service-section .icon-box .service-title {
  margin-left: 70px;
  font-weight: 700;
  margin-bottom: 15px;
  font-size: 18px;
  line-height: 1.2;
}
.service-section .icon-box .service-title a {
  color: #556270;
  transition: 0.3s;
  text-decoration: none;
}
.service-section .icon-box .service-para {
  margin-left: 70px;
  line-height: 24px;
  font-size: 14px;
}
.service-section .service-main-heading {
  color: #556270;
  padding: 0;
  margin-bottom: 20px;
  line-height: 1;
  font-size: 40px;
  font-weight: 600;
}
/* features cards end */
/* benefits start */
.benefit {
  background-color: #eef5f2;
}
.benefits {
  color: #556270;
  padding: 0;
  margin-bottom: 60px;
  line-height: 1;
  font-size: 40px;
  font-weight: 600;
}
/* Advantages css start from here */

a,
a:hover,
a:focus,
a:active {
  text-decoration: none;
  outline: none;
}
ul {
  margin: 0;
  padding: 0;
  list-style: none;
}
/* .heading {
    margin-top: 0px;
} */

.amazing_feature {
  padding-top: 80px;
  padding-bottom: 50px;
}
.single_feature {
  background: #fff none repeat scroll 0 0;
  box-shadow: 0 2px 30px rgba(0, 0, 0, 0.1);
  margin-bottom: 30px;
  padding: 40px 40px;
  display: inline-block;
  vertical-align: middle;
  -webkit-transform: translateZ(0);
  transform: translateZ(0);
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
  -moz-osx-font-smoothing: grayscale;
  position: relative;
  -webkit-transition-property: color;
  transition-property: color;
  -webkit-transition-duration: 0.3s;
  transition-duration: 0.3s;
}
.single_feature:before {
  content: "";
  position: absolute;
  z-index: -1;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: #0b0861;
  -webkit-transform: scaleY(0);
  transform: scaleY(0);
  -webkit-transform-origin: 50% 0;
  transform-origin: 50% 0;
  -webkit-transition-property: transform;
  transition-property: transform;
  -webkit-transition-duration: 0.3s;
  transition-duration: 0.3s;
  -webkit-transition-timing-function: ease-out;
  transition-timing-function: ease-out;
}
.single_feature:hover,
.single_feature:focus,
.single_feature:active {
  color: white;
}
.single_feature:hover:before,
.single_feature:focus:before,
.single_feature:active:before {
  -webkit-transform: scaleY(1);
  transform: scaleY(1);
}
.feature_icon {
}
.single_feature i {
  border: 1px solid #e8e8e9;
  border-radius: 50%;
  color: #333;
  float: left;
  font-size: 20px;
  height: 60px;
  line-height: 60px;
  margin-right: 15px;
  position: relative;
  text-align: center;
  transition: all 0.3s ease 0s;
  width: 60px;
  z-index: 3;
  margin-top: 25px;
}
.single_feature:hover i {
  background: #fff;
  border: 1px solid #fff;
  color: #0b0861;
}
.single_feature h3 {
  text-transform: capitalize;
  font-size: 20px;
  font-weight: 400;
  margin-top: 0px;
  overflow: hidden;
}
.single_feature:hover h3 {
  color: #fff;
}
.single_feature span {
  border-bottom: 1px dashed #ccc;
  display: block;
  margin: 15px auto 10px;
  width: 80px;
}
.single_feature p {
  margin-bottom: 0;
  overflow: hidden;
}
/* Advantages end here */
.advantages {
  color: #556270;
  padding: 0;
  margin-bottom: 50px;
  line-height: 1;
  font-size: 40px;
  font-weight: 600;
}
/* pricing cards css */
.card-pricing.popular:hover {
  /* z-index: 1; */
  border: 3px solid #007bff;
}
.card-pricing .list-unstyled li {
  padding: 0.5rem 0;
  color: #6c757d;
}
.pricings {
  color: #556270;
  padding: 0;
  margin-bottom: 30px;
  line-height: 1;
  font-size: 40px;
  font-weight: 600;
}
/* pricing card end css */
/* faq css start */
.grey {
  background-color: blue;
  margin-left: 45%;
  margin-top: 30px;
  color: #fff;
  padding: 6px 10px;
  border-radius: 4px;
  border: 1px solid blue;
}
.grey:hover {
  color: #fff;
}
.faq {
  color: #556270;
  padding: 0;
  margin-bottom: 30px;
  line-height: 1;
  font-size: 50px;
  font-weight: 600;
}
.story {
  color: #556270;
  padding: 0;
  margin-bottom: 10px;
  line-height: 1;
  font-size: 50px;
  font-weight: 600;
}
/* .wrapper {
  width: 60%;
} */
.cont {
  background-color: white;
  color: black;
  border-radius: 10px;
  box-shadow: 0 0px 5px 0 rgb(0, 0, 0, 0.25);
  margin: 20px 0;
}
.question {
  font-size: 1.2rem;
  font-weight: 600;
  padding: 20px 80px 20px 20px;
  position: relative;
  display: flex;
  align-items: center;
  cursor: pointer;
}
.question::after {
  content: "\276F";
  font-size: 1.2rem;
  position: absolute;
  right: 20px;
  transition: 0.2s;
}
.question.active::after {
  transform: rotate(90deg);
}
.answercont {
  max-height: 0;
  overflow: hidden;
  transition: 0.3s;
}
.answer {
  padding: 0 20px 20px;
  line-height: 1.5rem;
}
.question.active + .answercont {
}
@media screen and (max-width: 790px) {
  html {
    font-size: 14px;
  }
  .wrapper {
    width: 80%;
  }
}

/* case study start from here */
.case {
  background-color: #f8f9fa;
}
.center-heading {
  text-align: center;
}
.center-heading .section-title {
  font-weight: 400;
  font-size: 28px;
  color: #3b566e;
  letter-spacing: 1.1px;
  line-height: 38px;
  margin-bottom: 20px;
}
.center-heading.colored .section-title {
  color: #ffffff;
}
.center-text {
  text-align: center;
  font-weight: 400;
  font-size: 16px;
  color: #6f8ba4;
  line-height: 28px;
  letter-spacing: 1px;
  margin-bottom: 50px;
}
.center-text.colored {
  color: #c7e5ff;
}
.center-text p {
  margin-bottom: 30px;
}
.services-small-item {
  display: block;
  background: #fff;
  box-shadow: 0 1px 28px 0 rgba(0, 0, 0, 0.03);
  border-radius: 5px;
  padding: 40px 28px;
  text-align: center;
  /* -webkit-transition: all 0.3s ease 0s;
  -moz-transition: all 0.3s ease 0s;
  -o-transition: all 0.3s ease 0s;
  transition: all 0.3s ease 0s; */
  position: relative;
  /* z-index: 2; */
  margin-bottom: 30px;
}
.services-small-item:before {
  content: "";
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0px;
  left: 0px;
  border-radius: 5px;
  background-color: #191059;
  /* background-image: linear-gradient(135deg, #8093d0 0%, #0C152F 100%); */
  /* -webkit-transition: all 0.3s ease 0s;
  -moz-transition: all 0.3s ease 0s;
  -o-transition: all 0.3s ease 0s;
  transition: all 0.3s ease 0s; */
  opacity: 0;
}
.services-small-item.active:before,
.services-small-item:hover:before {
  opacity: 1;
}
.services-small-item.active .icon:before,
.services-small-item:hover .icon:before {
  opacity: 0.26;
}
.services-small-item.active .icon i,
.services-small-item:hover .icon i {
  background: -webkit-linear-gradient(#fff, #fff);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
.services-small-item.active .services-title,
.services-small-item:hover .services-title {
  color: #ffffff;
}
.services-small-item.active p,
.services-small-item:hover p {
  color: #ffffff;
}
.services-small-item.active .button i,
.services-small-item:hover .button i {
  background-image: linear-gradient(135deg, #fff 0%, #fff 100%) !important;
  color: #191059 !important;
}
.services-small-item:hover {
  /* margin-top: -15px; */
}
.services-small-item .icon {
  width: 139px;
  height: 113px;
  margin: auto;
  position: relative;
  margin-bottom: 20px;
  -webkit-transition: all 0.3s ease 0s;
  -moz-transition: all 0.3s ease 0s;
  -o-transition: all 0.3s ease 0s;
  transition: all 0.3s ease 0s;
}
.services-small-item .icon i {
  display: block;
  height: 67px;
  line-height: 67px;
  position: absolute;
  width: 100%;
  top: 22px;
  /* z-index: 2; */
  font-size: 28px;
  background-color: #191059;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  -webkit-transition: all 0.3s ease 0s;
  -moz-transition: all 0.3s ease 0s;
  -o-transition: all 0.3s ease 0s;
  transition: all 0.3s ease 0s;
}
.services-small-item .services-title {
  font-weight: 400;
  font-size: 16px;
  color: #3b566e;
  letter-spacing: 0.7px;
  margin-bottom: 15px;
  position: relative;
  /* z-index: 2; */
  -webkit-transition: all 0.3s ease 0s;
  -moz-transition: all 0.3s ease 0s;
  -o-transition: all 0.3s ease 0s;
  transition: all 0.3s ease 0s;
}
.services-small-item p {
  font-weight: 400;
  font-size: 14px;
  color: #6f8ba4;
  letter-spacing: 0.88px;
  line-height: 26px;
  position: relative;
  /* z-index: 2; */
  -webkit-transition: all 0.3s ease 0s;
  -moz-transition: all 0.3s ease 0s;
  -o-transition: all 0.3s ease 0s;
  transition: all 0.3s ease 0s;
  margin-bottom: 30px;
}
.services-small-item .button {
  position: relative;
  /* z-index: 2; */
}
.services-small-item .button i {
  width: 42px;
  height: 42px;
  background-color: #191059;
  line-height: 42px;
  text-align: center;
  -webkit-border-radius: 100px;
  -moz-border-radius: 100px;
  border-radius: 100px;
  color: #fff;
  padding-left: 3px;
}
.services-small-item:hover + .item-bg {
  bottom: 30px;
}
.btn:hover {
  color: #fff;
}
.primary {
  background-color: #191059;
  margin-left: 45%;
  margin-top: 30px;
  color: #fff;
}
/* case study end */

/* testimonial css start from here */
.testimonial {
  margin-top: 50px;
  min-height: 425px;
  position: relative;
  background: #f3f3f3;
  /* background-image: url("/imgs/blue-back.jpg"); */
  padding-top: 30px;
  padding-bottom: 30px;
  /* background-position: center;
        background-size: cover;  */
}
/* .top_border{
 box-shadow: rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgb(209, 213, 219) 0px 0px 0px 1px inset;
} */
#testimonial4 .carousel-inner:hover {
  cursor: grab;
  cursor: grab;
}
#testimonial4 .carousel-inner:active {
  cursor: grabbing;
  cursor: grabbing;
}
#testimonial4 .carousel-inner .item {
  overflow: hidden;
}
.testimonial4_indicators .carousel-indicators::-webkit-scrollbar {
  height: 3px;
}
.testimonial4_indicators .carousel-indicators::-webkit-scrollbar-thumb {
  background: #eeeeee;
  -webkit-border-radius: 0;
  border-radius: 0;
}
.testimonial4_control_button .carousel-control {
  top: 175px;
  opacity: 1;
  width: 40px;
  bottom: auto;
  height: 40px;
  font-size: 10px;
  cursor: pointer;
  font-weight: 700;
  overflow: hidden;
  line-height: 38px;
  text-shadow: none;
  text-align: center;
  position: absolute;
  background: transparent;
  border: 2px solid black;
  text-transform: uppercase;
  -webkit-border-radius: 100%;
  border-radius: 100%;
  -webkit-box-shadow: none;
  box-shadow: none;
  -webkit-transition: all 0.6s cubic-bezier(0.3, 1, 0, 1);
  transition: all 0.6s cubic-bezier(0.3, 1, 0, 1);
}
.testimonial4_control_button .carousel-control.left {
  left: 3%;
  top: 50%;
  right: auto;
}
.testimonial4_control_button .carousel-control.right {
  right: 3%;
  top: 50%;
  left: auto;
}
.testimonial4_control_button .carousel-control.left:hover,
.testimonial4_control_button .carousel-control.right:hover {
  color: #000;
  background: black;
  border: 2px solid black;
}
.testimonial4_header {
  top: 0;
  left: 0;
  bottom: 0;
  width: 550px;
  display: block;
  margin: 30px auto;
  text-align: center;
  position: relative;
}
.testimonial4_slider {
  width: 90%;
  margin: auto;
  /* padding: 20px; */
  position: relative;
}
.slider_img {
  width: 220px;
  display: block;
  /* color: black; */
  font-size: 18px;
  line-height: 46px;
  padding: 20px;
  position: relative;
}

.testimonial .carousel {
  padding-bottom: 50px;
}
.testimonial .carousel-control-next-icon,
.testimonial .carousel-control-prev-icon {
  width: 25px;
  height: 25px;
}
.carousel-control-prev {
  justify-content: flex-start;
}
.carousel-control-next {
  justify-content: end;
}
/* ------testimonial subscription button start from here-------*/

.input-holder {
  font-family: 16px;
  display: flex;
  /* align-items: left: ;; */
  align-items: flex-start;
  /* justify-content: center; */
  gap: 0.4em;
}
.input-holder input {
  padding-right: 8rem;
  font-size: 1rem;
  font-weight: 400;
  border-radius: 0.3rem;
  border: 1px solid #e0e0e0;
  box-shadow: inset 1px 1px 1px #e0e0e080;
  color: #4c575c;
  transition: all 0.25s ease 0s;
}
.input-holder input:focus {
  border-color: #409eff;
  outline: none;
  box-shadow: inset 1px 1px 1px #e0e0e080, 0 0 0 3px #409eff80;
}
.input-holder button {
  padding: 0.5rem 1rem;
  font-size: 1rem;
  font-weight: 600;
  border-radius: 0.3rem;
  border: 1px solid #3b82f6;
  background: #3b82f6;
  color: #e5e5e5;
  transition: all 0.25s ease 0s;
  cursor: pointer;
}
.input-holder button:focus {
  border-color: #409eff;
  outline: none;
  box-shadow: 0 0 0 3px #409eff80;
}
.label {
  pointer-events: none;
  position: absolute;
  top: 2.7rem;
  right: 1.5rem;
  color: #fff;
  font-weight: 700;
  font-size: 1.4rem;
  transition: all 0.2s;
  transform-origin: left;
}
.welcome-container img {
  width: 100%;
}
.label {
  font-size: 1rem;
}
/* testinomial end here */
/* footer css start from here */

/* footer css end */
.prodNav {
  margin: 50px 0 20px;
  background: #f5f5f5;
  width: 400px;
  padding: 6px;
  border-radius: 32px;
  margin-left: 340px;
}
/* Extra small devices (phones, 600px and down) */
@media only screen and (max-width: 600px) {
  .prodNav {
    margin-left: 20px;
  }
}
/* Small devices (portrait tablets and large phones, 600px and up) */
@media only screen and (min-width: 600px) {
  .prodNav {
    margin-left: 40px;
  }
}
/* Medium devices (landscape tablets, 768px and up) */
@media only screen and (min-width: 768px) {
  .prodNav {
    margin-left: 140px;
  }
}
/* Large devices (laptops/desktops, 992px and up) */
@media only screen and (min-width: 992px) {
  .prodNav {
    margin-left: 250px;
  }
}
/* Extra large devices (large laptops and desktops, 1200px and up) */
@media only screen and (min-width: 1200px) {
  .prodNav {
    margin-left: 340px;
  }
}
.prodNav .ptItem {
  padding: 9px 35px;
  line-height: 20px;
  border-radius: 20px;
  border: 1px solid transparent;
  font-weight: 500;
  cursor: pointer;
  display: inline-block;
  vertical-align: middle;
  transition: all 0.3s ease-in-out;
}
.prodNav .ptItem.active {
  background: #007bff;
  border-color: #007bff;
  color: #ffffff;
}
.prodNav:hover {
  background: #f5f5f5;
  border-color: #f5f5f5;
}
/* .prodMain {
  display: none;
  padding: 20px;
  color: #ffffff;
}
.prodMain.active {
  display: block;
} */
/* navbar css start from here */
.nav {
  z-index: 1;
  padding: 5px;
}

.sticky {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
}
.img_size {
  height: auto;
  width: 56px;
}
/* .navs{
  display: flex;
  justify-content: space-evenly;
      width: 100%;
} */
.navbar-light .navbar-nav .nav-link {
  color: white;
}
.navbar-light .navbar-nav .nav-link:hover {
  color: yellow !important;
}
.navbar-light .navbar-nav .act {
  color: yellow;
  /* font-weight: bold; */
}
.navbar-light .navbar-nav .act:hover {
  color: yellow;
  /* font-weight: bold; */
}
/* Extra small devices (phones, 600px and down) */
@media only screen and (max-width: 600px) {
  .navbar-light .navbar-toggle {
    color: white;
    border-color: white;
    /* width: %; */
    margin-left: 400px;
  }
}
/* Small devices (portrait tablets and large phones, 600px and up) */
@media only screen and (min-width: 600px) {
  .navbar-light .navbar-toggle {
    color: white;
    border-color: white;
    /* width: %; */
    margin-left: 450px;
  }
}
@media screen and (min-width: 354px) {
  .navbar-light .navbar-toggle {
    color: white;
    border-color: white;
    /* width: %; */
    margin-left: 300px;
  }
}
/* Medium devices (landscape tablets, 768px and up) */
@media only screen and (min-width: 768px) {
  .navbar-light .navbar-toggle {
    color: white;
    border-color: white;
    margin-left: 600px;
  }
}
/* Large devices (laptops/desktops, 992px and up) */
@media only screen and (min-width: 992px) {
  .navbar-light .navbar-toggle {
    display: none;
  }
}
/* Extra large devices (large laptops and desktops, 1200px and up) */
@media only screen and (min-width: 1200px) {
  .navbar-light .navbar-toggle {
    display: none;
  }
}
/* navbar end here */
</style>